import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import WizardStepContainer from '../WizardStepContainer'
import { WizardStylesContext } from '../WizardStylesContext'
import WizardStepButtons from '../WizardStepButtons'
import { navigate } from '../../../utils/marketIdPathFunctions'
import { useHistory } from 'react-router'
import AddInitialVote from '../../../pages/Investible/Voting/AddInitialVote';
import { processTextAndFilesForSave } from '../../../api/files';
import { updateInvestment } from '../../../api/marketInvestibles';
import { resetEditor } from '../../TextEditors/Utilities/CoreUtils';
import { addCommentToMarket } from '../../../contexts/CommentsContext/commentsContextHelper';
import { partialUpdateInvestment, usePresences } from '../../../contexts/MarketPresencesContext/marketPresencesHelper';
import { CommentsContext } from '../../../contexts/CommentsContext/CommentsContext'
import { MarketPresencesContext } from '../../../contexts/MarketPresencesContext/MarketPresencesContext'
import _ from 'lodash'
import { getAcceptedStage, getFullStage } from '../../../contexts/MarketStagesContext/marketStagesContextHelper';
import { stageChangeInvestible } from '../../../api/investibles';
import { onInvestibleStageChange } from '../../../utils/investibleFunctions';
import { MarketStagesContext } from '../../../contexts/MarketStagesContext/MarketStagesContext';
import { getInvestible } from '../../../contexts/InvestibesContext/investiblesContextHelper';
import { getMarketInfo } from '../../../utils/userFunctions';
import { InvestiblesContext } from '../../../contexts/InvestibesContext/InvestiblesContext';
import JobDescription from '../../InboxWizards/JobDescription';
import useDoableStageGuard from '../JobStage/useDoableStageGuard';

function JobApproveStep(props) {
  const { marketId, groupId, updateFormData = () => {}, formData = {}, onFinish } = props;
  const confirmDoableQuestions = useDoableStageGuard(marketId);
  const [commentsState, commentsDispatch] = useContext(CommentsContext);
  const [, marketPresencesDispatch] = useContext(MarketPresencesContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [investiblesState, investiblesDispatch] = useContext(InvestiblesContext);
  const presences = usePresences(marketId);
  const history = useHistory();
  const validForm = formData.approveQuantity != null;
  const classes = useContext(WizardStylesContext)
  const { investibleId } = formData;
  const inv = getInvestible(investiblesState, investibleId);
  const marketInfo = getMarketInfo(inv, marketId) || {};
  const { stage: stageId, required_approvers: requiredApprovers, assigned } = marketInfo;
  const editorName = `newjobapproveeditor${investibleId}`;
  const myPresence = presences.find((presence) => presence.current_user) || {};
  const isAssignedToMe = assigned?.includes(myPresence.id);

  function onNext() {
    const {approveUploadedFiles, approveReason, approveQuantity} = formData;
    const {
      uploadedFiles: filteredUploads,
      text: tokensRemoved,
    } = processTextAndFilesForSave(approveUploadedFiles, approveReason);
    const reasonNeedsUpdate = !_.isEmpty(tokensRemoved);
    const updateInfo = {
      marketId,
      investibleId,
      groupId,
      newQuantity: parseInt(approveQuantity),
      currentQuantity: 0,
      newReasonText: tokensRemoved,
      reasonNeedsUpdate,
      uploadedFiles: filteredUploads
    };
    if (!reasonNeedsUpdate) {
      const yourVote = myPresence.investments?.find((investment) =>
        investment.investible_id === investibleId);
      updateInfo.currentReasonId = yourVote?.comment_id;
    }
    return updateInvestment(updateInfo).then((result) => {
      const { commentResult, investmentResult } = result;
      const { commentAction, comment } = commentResult;
      if (commentAction !== "NOOP") {
        addCommentToMarket(comment, commentsState, commentsDispatch);
      }
      partialUpdateInvestment(marketPresencesDispatch, investmentResult, true);
      return formData;
    })
  }

  function start() {
    const fullMoveStage = getAcceptedStage(marketStagesState, marketId);
    if (confirmDoableQuestions(investibleId, fullMoveStage.id)) {
      return Promise.resolve(false);
    }
    const fullCurrentStage = getFullStage(marketStagesState, marketId, stageId) || {};
    const moveInfo = {
      marketId,
      investibleId,
      stageInfo: {
        current_stage_id: stageId,
        stage_id: fullMoveStage.id,
      },
    };
    return stageChangeInvestible(moveInfo)
      .then((newInv) => {
        onInvestibleStageChange(fullMoveStage.id, newInv, investibleId, marketId, commentsState,
          commentsDispatch, investiblesDispatch, () => {}, marketStagesState, undefined,
          fullCurrentStage, marketPresencesDispatch);
        onFinish(formData);
        return formData;
      });
  }

  function onTerminate() {
    const { link } = formData;
    resetEditor(editorName);
    navigate(history, link);
  }

  function onApproveChange (key) {
    return (data) => {
      const update = {
        [key]: data,
      };
      updateFormData(update);
    };
  }


  function onQuantityChange(event) {
    const {value} = event.target;
    updateFormData({
      approveQuantity: parseInt(value, 10)
    });
  }

  const {approveQuantity} = formData;

  return (
    <WizardStepContainer
      {...props}
      isLarge
    >
      <Typography className={classes.introText} variant="h6">
        How certain are you this job should be done?
      </Typography>
      <JobDescription marketId={marketId} investibleId={investibleId}/>
      <div style={{paddingBottom: '1rem'}} />
      <AddInitialVote
        marketId={marketId}
        onChange={onQuantityChange}
        newQuantity={approveQuantity}
        onEditorChange={onApproveChange('approveReason')}
        onUpload={onApproveChange('approveUploadedFiles')}
        editorName={editorName}
      />
      <div className={classes.borderBottom}/>
      <WizardStepButtons
        {...props}
        finish={onFinish}
        validForm={validForm}
        showTerminate={true}
        onNext={onNext}
        showOtherNext={_.isEmpty(requiredApprovers) && isAssignedToMe}
        otherNextValid
        onOtherNext={start}
        onOtherDoAdvance={false}
        otherNextLabel="skipAllApprovals"
        onTerminate={onTerminate}
        terminateLabel="JobWizardGotoJob"
        nextLabel="JobWizardApproveJob"
      />
    </WizardStepContainer>
  )
}

JobApproveStep.propTypes = {
  updateFormData: PropTypes.func,
  formData: PropTypes.object,
}

export default JobApproveStep
